(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wixstores", [], factory);
	else if(typeof exports === 'object')
		exports["wixstores"] = factory();
	else
		root["wixstores"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	__webpack_require__.p = typeof window !== 'undefined' && window.__STATICS_BASE_URL__ || __webpack_require__.p;
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.get = function (getter, fallback) {
    try {
        var val = getter();
        return val !== void 0 ? val : fallback;
    }
    catch (e) {
        return fallback;
    }
};
exports.omit = function (key) { return function (obj) {
    var _a = key, _v = obj[_a], rest = __rest(obj, [typeof _a === "symbol" ? _a : _a + ""]);
    return rest;
}; };
exports.omitMedia = exports.omit('media');
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = __webpack_require__(8);
var contants_1 = __webpack_require__(9);
var controllers_1 = __webpack_require__(10);
(function () {
    var raven;
    var context = {
        addToCartListeners: [],
    };
    function initAppForPage(_b, _a, _w, services) {
        var instance = _b.instance;
        raven = services && services.monitoring && services.monitoring.createMonitor(contants_1.SENTRY_DSN);
        var url = _.get(wix, 'location.baseUrl');
        raven && raven.setUserContext({
            id: url,
            url: url
        });
        context._instance = instance;
        return Promise.resolve();
    }
    var reportError = context.reportError = function (e) {
        raven && raven.captureException(e);
        throw e;
    };
    var wrapExportsRaven = utils_1.wrapExports(reportError);
    var controllerByType = {
        '1380bbc4-1485-9d44-4616-92e36b1ead6b': controllers_1.cartWidgetController,
        '13a94f09-2766-3c40-4a32-8edb5acdd8bc': controllers_1.productPageController
    };
    function createControllers(controllerConfigs) {
        return controllerConfigs
            .map(function (_b) {
            var type = _b.type;
            return controllerByType[type] ?
                Promise.resolve(wrapExportsRaven(controllerByType[type](context))) :
                Promise.resolve(controllers_1.emptyController(context));
        });
    }
    module.exports = wrapExportsRaven({
        initAppForPage: initAppForPage,
        createControllers: createControllers,
        exports: {
            setAddToCart: function (cb) {
                context.addToCart = cb;
            },
            setGetProduct: function () {
                throw new Error('Deprecated');
            },
            notifyOnAddToCart: function (item) {
                context.addToCartListeners.forEach(function (listener) { return listener(item); });
            }
        }
    });
})();


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
exports.wrapTryCatch = function (onCatch) { return function (fn) {
    return function () {
        try {
            return fn.apply(null, arguments);
        }
        catch (e) {
            onCatch && onCatch(e);
        }
    };
}; };
exports.wrapExports = function (onCatch) { return function (o) {
    var wrapper = exports.wrapTryCatch(onCatch);
    var wrapFunction = _.reduce(o, function (result, value, key) {
        var _a;
        return (tslib_1.__assign((_a = {}, _a[key] = _.isFunction(value) ? wrapper(value) : value, _a), result));
    }, {});
    return _.reduce(wrapFunction, function (result, value, key) {
        var _a;
        return (tslib_1.__assign((_a = {}, _a[key] = key === 'exports' ? exports.wrapExports(onCatch)(value) : value, _a), result));
    }, {});
}; };


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.SENTRY_DSN = 'https://8bc29fb6cd064a49a9945743de020bf2@sentry.io/1186457';


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(11), exports);
tslib_1.__exportStar(__webpack_require__(12), exports);
tslib_1.__exportStar(__webpack_require__(16), exports);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class CartIcon
 * @summary An icon that leads users to the shopping cart.
 * @classdesc
 *  The shopping cart icon displays how many items are in the shopping cart.
 *  When users click on the cart icon, a cart sidebar opens on the current page.
 *  You can use a `CartIcon` element to programmitically add items to a user's
 *  cart.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.tpapps.TPAWidget
 * @tagname cartIcon
 */
/**
 * @typedef {external:Object} $w.CartIcon~AddToCartOptions
 * @summary An object used when adding a product to the shopping cart with options.
 * @property {external:Object} choices Product options to use when adding the
 *  product to the cart. The object contains key:value pairs where the key is the
 *  option name and the value is the chosen option value.
 * @property {$w.CartIcon~AddToCartCustomTextField} customTextField Custom custom
 *  text fields to use when adding the product to the cart.
 * @see [addToCart( )](#addToCart)
 */
/**
 * @typedef {external:Object} $w.CartIcon~AddToCartCustomTextField
 * @summary An object used to pass a custom text field when adding a product to
 *  the shopping cart with options.
 * @property {external:String} title Custom text field title.
 * @property {external:String} value Custom text field value.
 * @see [addToCart( )](#addToCart)
 * @see [AddToCartOptions](#AddToCartOptions)
 */
exports.cartWidgetController = function (context) { return ({
    pageReady: function (_$w) {
        //
    },
    exports: {
        /**
         * @function addToCart
         * @syntax
         * function addToCart(productId: string, [quantity: number], [options: AddToCartOptions]): Promise&lt;void&gt;
         * @summary Adds a product to the shopping cart.
         * @description
         *  The `addToCart()` function returns a Promise that is resolved when the
         *  specified product is added to the shopping cart.
         *
         *  Use the optional `quantity` parameter to add more than one product unit to
         *  the shopping cart at one time. If `quantity` is omitted, one product unit
         *  will be added.
         *
         *  Use the `options` parameter to specify the product options to choose when
         *  adding the product to the cart. For example, if a product comes in different
         *  sizes, you can specify the size that should be added to the cart. If the
         *  product you are adding to the cart has options, you must specify which
         *  options should be chosen.
         *
         *  You can use the [`getProductOptionsAvailability()`](wix-stores-backend.html#getProductOptionsAvailability)
         *  to determine if an item with specific options is available for purchase.
         *
         *  Also use the `options` parameter to specify the values for the product's
         *  custom text fields. If the product you are adding to the cart has mandatory
         *  custom text fields, you must specify values for those fields.
         * @param {external:String} productID The ID of the product to add to the cart.
         * @param {external:Number} [quantity] The number of product units to add to
         *  the cart. If omitted, one product unit will be added.
         * @param {$w.CartIcon~AddToCartOptions} [options] Product options.
         * @returns {Promise}
         * @fulfill {void} When the product has been added to the cart.
         * @snippet [CartIcon-addToCart.es6=Add a product to the cart]
         * @snippet [CartIcon-addToCart_button.es6=Add a product to the cart from a button click]
         * @snippet [CartIcon-addToCart_quantity.es6=Add two units of a product to the cart]
         * @snippet [CartIcon-addToCart_options.es6=Add a product to the cart with options]
         * @memberof $w.CartIcon
         */
        addToCart: function () {
            return context.addToCart && context.addToCart.apply(null, arguments);
        },
        onAddToCart: function (cb) {
            context.addToCartListeners.push(cb);
            return Promise.resolve();
        }
    }
}); };


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var product_mapper_1 = __webpack_require__(13);
/**
 * @class ProductPage
 * @summary A store page for a specific product.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @viewername wysiwyg.viewer.components.tpapps.TPAWidget
 * @tagname productPage
 */
/**
 * @typedef {external:Object} $w.ProductPage~StoreProductRibbon
 * @summary An object representing a ribbon for a store product.
 * @property {external:String} text Ribbon text.
 * @see [getProduct( )](#getProduct)
 * @see [StoreProduct](#StoreProduct)
 */
/**
 * @typedef {external:Object} $w.ProductPage~StoreProductAdditionalInfoSection
 * @summary An object representing an additional info section for a store product.
 * @property {external:String} title Section title.
 * @property {external:String} description Section description.
 * @see [getProduct( )](#getProduct)
 * @see [StoreProduct](#StoreProduct)
 */
/**
 * @typedef {external:Object} $w.ProductPage~StoreProductOptionsChoice
 * @summary An object representing an options choice for a store product.
 * @property {external:Number} value Choice value.
 * @property {external:Number} description Choice description.
 * @property {$w.ProductPage~StoreProductOptionsChoiceMedia} media Choice media.
 * @property {external:Boolean} inStock Indicates whether the product with this choice is in stock.
 * @property {external:Boolean} visible Indicates whether the product with this option is visible.
 * @see [getProduct( )](#getProduct)
 * @see [StoreProductOption](#StoreProductOption)
 */
/**
 * @typedef {external:Object} $w.ProductPage~StoreProductOptionsChoiceMedia
 * @summary An object representing the choice media
 * @property {external:String} mainMedia Main choice media item (image or video thumbnail) URL.
 * @property {($w.Gallery~ImageItem[]|$w.Gallery~VideoItem[])} mediaItems List of choice media items.
 * @see [getProduct( )](#getProduct)
 * @see [StoreProductOptionsChoice](#StoreProductOptionsChoice)
 */
/**
 * @typedef $w.ProductPage~StoreProductOptions
 * @summary An object representing all the available options for a store product.
 * @property {$w.ProductPage~StoreProductOption} optionKey Name of the option. This key name is
 *  dependent on the options added to the product. For example, if a product
 *  has a size option, this key will be something like "Size".
 * @see [getProduct( )](#getProduct)
 * @see [StoreProduct](#StoreProduct)
 */
/**
 * @typedef $w.ProductPage~StoreProductOption
 * @summary An object representing an option for a store product.
 * @property {external:String} optionType Option type. Either `"color"` or `"drop_down"`.
 * @property {external:String} name Option name.
 * @property {$w.ProductPage~StoreProductOptionsChoice[]} choices Option choices.
 * @see [getProduct( )](#getProduct)
 * @see [StoreProductOptions](#StoreProductOptions)
 */
/**
 * @typedef {external:Object} $w.ProductPage~StoreProductCustomTextFields
 * @summary An object representing a custom text field for a store product.
 * @property {external:String} title Product customization field title.
 * @property {external:String} maxLength Maximum length of product customization field in characters.
 * @see [getProduct( )](#getProduct)
 * @see [StoreProduct](#StoreProduct)
 */
/**
 * @typedef {external:Object} $w.ProductPage~StoreProduct
 * @summary An object representing a product in a store.
 * @property {external:String} _id Product ID.
 * @property {external:String} name Product name.
 * @property {external:String} description Product description.
 * @property {external:String} mainMedia Main product media item (image or video thumbnail) URL.
 * @property {($w.Gallery~ImageItem[]|$w.Gallery~VideoItem[])} mediaItems List of product media items.
 * @property {external:String} sku Product stock keeping unit value.
 * @property {$w.ProductPage~StoreProductRibbon[]} ribbons List of product ribbons.
 * @property {external:String} currency Product currency.
 * @property {external:Number} price Product price.
 * @property {external:Number} discountedPrice Discounted product price.
 * @property {external:String} formattedPrice Product price formatted with the currency.
 * @property {external:String} formattedDiscountedPrice Discounted product price formatted with the currency.
 * @property {external:Boolean} trackInventory Indicates whether inventory is tracked for the product.
 * @property {external:Boolean} inStock Indicates whether the product is in stock.
 * @property {external:Number} quantityInStock Number of units currently in stock.
 * @property {$w.ProductPage~StoreProductAdditionalInfoSection[]} additionalInfoSections Additional product information sections.
 * @property {$w.ProductPage~StoreProductOptions} productOptions All the available options for a store product.
 * @property {external:String} productPageUrl Product page relative URL.
 * @property {external:Boolean} manageVariants Indicates whether product variants are managed.
 * @property {$w.ProductPage~StoreProductCustomTextFields[]} customTextField List of product customization fields.
 * @property {external:String} productType Product type. Either `"physical"` or `"digital"`.
 * @property {external:String} slug Product slug.
 * @property {external:String} weight Product weight.
 * @snippet [ProductPage-getProduct.es6=Get the current product's information]
 * @see [getProduct( )](#getProduct)
 */
exports.productPageController = function (context) {
    var fetchProduct = function () {
        var productName = _.last(wix.location.path);
        return fetch("/_api/catalog-server/api/v1/products/query", {
            method: 'post',
            headers: { Authorization: context._instance },
            body: JSON.stringify({
                query: {
                    filter: JSON.stringify({ slug: productName })
                }
            })
        })
            .then(function (response) { return response.json(); })
            .then(function (json) { return json.products && json.products[0]; });
    };
    return {
        pageReady: function (_$w) {
            //
        },
        exports: {
            /**
             * @function getProduct
             * @syntax
             * function getProduct(): Promise&lt;StoreProduct&gt;
             * @summary Gets the all the information associated with the currect product.
             * @description
             *  The `getProduct()` function returns a Promise that is resolved when all
             *  of the information about the product shown on the `ProductPage` is
             *  retrieved.
             * @returns {Promise}
             * @fulfill {$w.ProductPage~StoreProduct} When the information associated with the currect product has been retrieved.
             * @snippet [ProductPage-getProduct.es6=Get the current product's information]
             * @memberof $w.ProductPage
             */
            getProduct: function () {
                return fetchProduct()
                    .then(function (product) {
                    if (product) {
                        return product_mapper_1.productMapper(product);
                    }
                    else {
                        throw new Error('product not found');
                    }
                })
                    .catch(context.reportError);
            }
        }
    };
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mappers_1 = __webpack_require__(14);
var utils_1 = __webpack_require__(1);
exports.productMapper = function (item) {
    return __assign({ _id: item.id, name: item.name, description: item.description }, mappers_1.mediaMapper(item.media), { sku: item.sku, ribbons: item.ribbons, currency: item.price.currency, price: item.price.price, discountedPrice: item.price.discountedPrice, formattedPrice: item.price.formatted.price, formattedDiscountedPrice: item.price.formatted.discountedPrice, trackInventory: item.stock.trackInventory, inStock: item.stock.inStock, quantityInStock: item.stock.quantity, additionalInfoSections: item.additionalInfoSections, productOptions: (item.productOptions || []).reduce(function (options, option) {
            var _a;
            return Object.assign(options, (_a = {},
                _a[option.name] = __assign({}, utils_1.omitMedia(option), { choices: option.choices.map(function (choice) { return (__assign({}, utils_1.omitMedia(choice), mappers_1.mediaMapper(choice.media))); }) }),
                _a));
        }, {}), productPageUrl: item.productPageUrl.path, customTextFields: item.customTextFields, manageVariants: item.manageVariants, productType: item.productType, slug: item.slug, weight: item.weight });
};
//# sourceMappingURL=product.mapper.js.map

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var product_dto_1 = __webpack_require__(15);
var utils_1 = __webpack_require__(1);
var buildImage = function (mediaItem) {
    var imageData = utils_1.get(function () { return mediaItem.image.url.split('/').reverse(); }, []);
    var title = utils_1.get(function () { return mediaItem.title; }, '');
    return {
        src: exports.buildImageUrl(mediaItem),
        description: '',
        title: title,
        link: undefined,
        type: 'Image'
    };
};
var buildVideo = function (mediaItem) {
    var imageData = utils_1.get(function () { return mediaItem.thumbnail.url.split('/').reverse(); }, []);
    var videoData = utils_1.get(function () { return mediaItem.video.files[0].url.split('/').reverse(); }, []);
    var uri = utils_1.get(function () { return videoData[3]; }, '');
    var filename = utils_1.get(function () { return videoData[0]; }, 'file');
    var title = utils_1.get(function () { return mediaItem.title; }, '');
    var posterUri = utils_1.get(function () { return imageData[4]; }, '');
    var posterWidth = utils_1.get(function () { return mediaItem.thumbnail.width; }, 100);
    var posterHeight = utils_1.get(function () { return mediaItem.thumbnail.height; }, 100);
    return {
        src: "wix:video://v1/" + uri + "/" + filename + "#posterUri=" + posterUri + "&posterWidth=" + posterWidth + "&posterHeight=" + posterHeight,
        description: '',
        title: title,
        link: undefined,
        type: 'Video',
        thumbnail: exports.buildImageUrl(mediaItem)
    };
};
exports.mediaToGalleryItem = function (mediaItem) {
    if (!mediaItem) {
        return undefined;
    }
    if (mediaItem.mediaType === product_dto_1.MediaItemType.video) {
        return buildVideo(mediaItem);
    }
    else {
        return buildImage(mediaItem);
    }
};
exports.buildImageUrl = function (mediaItem) {
    var missingMedia = {
        url: 'https://static.wixstatic.com/media/614034_103e8f4ab0ae4536a38b319d3eb437ed~mv2.png/v1/fill/w_500,h_500/missing-media.png',
        width: 500,
        height: 500
    };
    var media = mediaItem ?
        (mediaItem.mediaType === product_dto_1.MediaItemType.video ? mediaItem.thumbnail : mediaItem.image) :
        missingMedia;
    var imageData = utils_1.get(function () { return media.url.split('/').reverse(); }, []);
    var uri = utils_1.get(function () { return imageData[4]; }, '');
    var fileName = utils_1.get(function () { return imageData[0]; }, 'file');
    return "wix:image://v1/" + uri + "/" + fileName + "#originWidth=" + media.width + "&originHeight=" + media.height;
};
exports.mediaMapper = function (media) { return ({
    mainMedia: (media || null) && exports.buildImageUrl(media.mainMedia),
    mediaItems: (media && media.items || []).map(exports.mediaToGalleryItem).filter(Boolean)
}); };
//# sourceMappingURL=mappers.js.map

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var OptionType;
(function (OptionType) {
    OptionType["drop_down"] = "drop_down";
    OptionType["color"] = "color";
})(OptionType = exports.OptionType || (exports.OptionType = {}));
var MediaItemType;
(function (MediaItemType) {
    MediaItemType["image"] = "image";
    MediaItemType["video"] = "video";
    MediaItemType["audio"] = "audio";
    MediaItemType["document"] = "document";
    MediaItemType["zip"] = "zip";
})(MediaItemType = exports.MediaItemType || (exports.MediaItemType = {}));
var ProductType;
(function (ProductType) {
    ProductType["physical"] = "physical";
    ProductType["digital"] = "digital";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
//# sourceMappingURL=product.dto.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyController = function (_context) { return ({
    pageReady: function () { },
    exports: {}
}); };


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// viewer.bundle.min.js